import { atom } from 'recoil';

export const TextSearchState = atom({
    key: 'TextSearchState', 
    default: '', 
});



